"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
exports.OsmosysAppLayout = ({ children }) => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { className: "flex-full-col overflow-y-auto", osysName: "OsmosysAppLayout" },
        react_1.default.createElement(react_1.default.Fragment, null, children)));
};
//# sourceMappingURL=OsmosysAppLayout.js.map